import api from "./api";

const PATH = "/api/v1/zillow";

export interface ZillowProperty {
  address: string;
  zpid: string;
  amount?: number;
}

export interface Zestimate {
  value: number;
}

export const ZillowService = {
  async search(location: string): Promise<ZillowProperty[]> {
    const response = await api.get(`${PATH}/search`, {
      params: { location },
    });
    return response.data.data;
  },
  async zestimate(zpid: string): Promise<Zestimate> {
    const response = await api.get(`${PATH}/zestimate`, {
      params: { zpid },
    });
    return response.data.data;
  },
};
